import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./payroll.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>New Business Registration</h3>
                </header>
                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>Start Your Business with Confidence</h3>
                        <p>
                            Starting a new business is exciting, but the process
                            of registration can feel overwhelming. At{" "}
                            <b>Serene Tax</b>, we simplify the process and guide
                            you every step of the way. From choosing the right
                            business structure to filing the necessary
                            paperwork, we ensure your business is set up for
                            success and compliance with all federal, state, and
                            local regulations.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>{" "}
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>
                            Why Choose Serene Tax for Business Registration?
                        </h3>
                        <p>
                            <b>Expert Guidance:</b>We help you navigate the
                            complexities of business registration with ease.
                        </p>
                        <p>
                            <b>Customized Solutions:</b> Our team tailors
                            services to your unique business needs and goals.
                        </p>
                        <p>
                            <b>Comprehensive Support:</b> We handle all the
                            paperwork and formalities, saving you time and
                            effort.
                        </p>
                        <p>
                            <b>Compliance Guaranteed:</b> Avoid errors and
                            delays with our precise and knowledgeable service.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Our Business Registration Services Include:</h3>
                        <p>
                            <b>1.Business Structure Selection :</b>We help you
                            choose the most suitable business structure (LLC,
                            Corporation, Sole Proprietorship, Partnership, etc.)
                            based on your goals, liability concerns, and tax
                            implications.
                        </p>
                        <p>
                            <b>2.Entity Name Reservation</b>
                            Ensure your business name is unique and compliant
                            with state regulations. We handle the name search
                            and reservation process.
                        </p>
                        <p>
                            <b>3.EIN Application :</b>
                            We assist in obtaining your Employer Identification
                            Number (EIN) from the IRS, essential for tax
                            purposes and hiring employees.
                        </p>
                        <p>
                            <b>4.State and Local Registration</b>We manage your
                            state and local registrations, including licenses,
                            permits, and other legal requirements.
                        </p>
                        <p>
                            <b>5.Articles of Incorporation/Organization :</b>
                            We prepare and file your formation documents,
                            ensuring accuracy and compliance with state
                            requirements.
                        </p>
                        <p>
                            <b>6.Operating Agreements and Bylaws :</b>
                            For LLCs and Corporations, we draft essential legal
                            documents that outline your business’s operational
                            framework.
                        </p>
                        <p>
                            <b>7.Tax Registrations :</b>We handle federal,
                            state, and local tax registrations, ensuring your
                            business is ready for tax compliance from day one.
                        </p>
                        <p>
                            <b>8.Ongoing Compliance Support :</b>
                            Beyond registration, we provide guidance on
                            maintaining compliance, including annual filings and
                            renewals
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Benefits of Professional Business Registration
                            Services
                        </h3>
                        <p>
                            <b>Save Time :</b>: Focus on launching your business
                            while we handle the paperwork
                        </p>
                        <p>
                            <b>Avoid Mistakes:</b>
                            Reduce the risk of errors or omissions that can
                            delay your registration.
                        </p>
                        <p>
                            <b>Gain Peace of Mind :</b>
                            Rest assured that your business is set up properly
                            and legally.
                        </p>
                        <p>
                            <b>Access to Expertise :</b>
                            Benefit from our in-depth knowledge of registration
                            requirements and regulations.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Industries We Serve</h3>
                        <h4>
                            We assist entrepreneurs across various industries,
                            including:
                        </h4>
                        <ul>
                            <li>Retail and E-Commerce</li>
                            <li>Healthcare and Wellness</li>
                            <li>Technology Startups y</li>
                            <li>Consulting and Professional Services</li>
                            <li>Nonprofits and Charities</li>
                            <li>Hospitality and Food Services</li>
                        </ul>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Our Process</h3>
                        <p>
                            <b>1.Initial Consultation :</b>
                            <br />
                            We discuss your business goals, structure options,
                            and any special considerations to ensure the best
                            setup for your needs.
                        </p>
                        <p>
                            <b>2.Document Preparation</b>
                            <br />
                            Our team prepares and files all necessary paperwork,
                            ensuring accuracy and compliance.
                        </p>
                        <p>
                            <b>3.Registration and Filing</b>
                            <br />
                            We handle the submission of your documents to the
                            appropriate federal, state, and local agencies.
                        </p>
                        <p>
                            <b>4.Final Review and Delivery</b>
                            <br />
                            Once your business is registered, we provide you
                            with all official documents and next steps for
                            starting operations.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Why Serene Tax?</h3>
                        <p>
                            <b>Experienced Professionals:</b> Our team has With
                            years of experience, we ensure a smooth and
                            hasslefree registration process.
                        </p>
                        <p>
                            <b>Affordable Services:</b>Our pricing is
                            transparent and competitive, with no hidden fees.
                        </p>
                        <p>
                            <b>Personalized Attention:</b>
                            We treat every client’s business as if it were our
                            own, delivering dedicated and professional service.
                        </p>
                        <p>
                            <b>Long-Term Support: </b>Our relationship doesn’t
                            end with registration—we’re here to support your
                            business as it grows.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Start Your Business the Right Way</h3>
                        <p>
                            Let <b>Serene Tax</b> take the stress out of
                            business registration. From paperwork to compliance,
                            we’ve got you covered so you can focus on bringing
                            your vision to life.
                            <br />
                            Contact us today for a consultation.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735- 8875]</b>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
